import { useState,useRef } from "react";
import { useToast } from './ToastContext'; 
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";

import "react-multi-date-picker/styles/layouts/mobile.css";
import InputIcon from "react-multi-date-picker/components/input_icon";


function toEnglishNumber(str) {
  return str.replace(/[۰-۹]/g, (digit) =>
    String.fromCharCode(digit.charCodeAt(0) - 1728)
  );
}
function EmploymentForm() {
    const fileInputRef = useRef(null);
    const [Name, setName] = useState("");
    const [LastName, setLastName] = useState("");
    const [birthyear, setbirthyear] = useState(new DateObject());
    const [Mariage, setMariage] = useState("");
    const [Mobile, setMobile] = useState("");
    const [Phone, setPhone] = useState("");
    const [Address, setAddress] = useState("");
    const [Grade, setGrade] = useState("");
    const [Filde, setFilde] = useState("");
    const [InEducate, setInEducate] = useState("");
    const [favorites, setFavorites] = useState([]);
    const [OldJob, setOldJob] = useState("");
    const [oldJobReject, setoldJobReject] = useState("");
    const [skill, setskill] = useState("");
    const [valideForm, setvalideForm] = useState("");
    
    
    
    const [SelectedFile, setSelectedFile] = useState();
    const {showMessage,showLoading } = useToast();

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        if (checked) {
            setFavorites([...favorites, value]); // مقدار جدید را اضافه کن
        } else {
            setFavorites(favorites.filter((item) => item !== value)); // مقدار را حذف کن
        }
    };
    const attachFile = () => {
        fileInputRef.current.click();
    };
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };
    
    const handleSubmit = async () => {

        const loadingToastId = showLoading("در حال انجام عملیات...");
        const formData = new FormData();
        formData.append("name", Name);
        formData.append("familly", LastName);
        formData.append("birth_year", birthyear.convert(persian, persian_en).format());
        formData.append("mariage", Mariage);
        formData.append("mobile", toEnglishNumber(Mobile));
        formData.append("phone", toEnglishNumber(Phone));
        formData.append("address", Address);
        formData.append("in_educate", InEducate);

        favorites.forEach((item, index) => {
            formData.append(`favorit[${index}]`, item); // مقدار آرایه را اضافه کن
        });
        formData.append("grade", Grade);
        formData.append("filde", Filde);
        formData.append("old_job", OldJob);
        formData.append("old_job_reject", oldJobReject);
        formData.append("skill", skill);
        formData.append("checkbox_1588489415", valideForm);
        formData.append("csv_file", SelectedFile);
       
        formData.append("gSubmitForm", 1);
        formData.append("id_shop", 1);
        formData.append("id_lang", 1);
        formData.append("idform", 1);
        formData.append("usingajax",1);
        
        try {
            const response = await fetch(`${global.config.domain_url}/form/-g1.html`, {
                method: "POST",
                body: formData,
            });
            const data = await response.json();
          
            if (data.errors=='0') {
                showMessage('success', "عملیات موفقیت‌آمیز بود!", 3000, loadingToastId);
                setName("");
                setLastName("");

               
            } else {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data.thankyou, "text/html");
                const liElements = doc.querySelectorAll('li');
                const extractedErrors = Array.from(liElements).map(li => li.textContent);
                extractedErrors.forEach((error,index)=>{
                    if(index==0)
                    {
                        showMessage('error',error, 3000, loadingToastId);
                    }
                    else
                    {
                        showMessage('error',error, 3000);
                    }
                });
                
               
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            showMessage('error', 'ارسال فرم با مشکل مواجه شد.', 3000, loadingToastId);
            
        }
    };
    return(
        
        <div id="employee" className="container">
            <h4 className="mt-5">فرم استخدام</h4>
            <div className="d-flex flex-wrap mt-5">
                <div className="col-lg-6 col-12">
                    <label>نام</label>
                    <input  className="form-input col-12"
                        type="text"
                        placeholder="نام"
                        value={Name}
                        onChange={(e) => setName(e.target.value)} 
                    />
                </div>
                <div className="col-lg-6 col-12">
                    <label>نام خانوادگی</label>
                    <input  className="form-input col-12"
                        type="text"
                        placeholder="نام خانوادگی"
                        value={LastName}
                        onChange={(e) => setLastName(e.target.value)} 
                    />
                </div>
                <div className="col-lg-6 col-12 mt-5">
                    <label>سال تولد</label>
                    <DatePicker  
                        className="rmdp-mobile"   
                        containerClassName="form-input col-12" 
                        placeholder="سال تولد"   
                        onlyYearPicker 
                        value={birthyear}  
                        render={<InputIcon/>} 
                        calendar={persian} 
                        locale={persian_fa} 
                        calendarPosition="bottom-right" 
                        onChange={setbirthyear}
                    />
                </div>
                <div className="col-lg-6 col-12 mt-5">
                    <label>وضعیت تاهل</label>
                    <select  className="form-input col-12"
                        type="text"
                        onChange={(e) => setMariage(e.target.value)} 
                    >
                        <option value="مجرد">انتخاب کنید</option>
                        <option value="مجرد">مجرد</option>
                        <option value="متاهل">متاهل</option>
                    </select>
                </div>
                <div className="col-lg-6 col-12 mt-5">
                    <label>تلفن همراه</label>
                    <input  className="form-input col-12"
                        dir="ltr"
                        type="text"
                        placeholder="+98 000 000 00 00"
                        value={Mobile}
                        onChange={(e) => setMobile(e.target.value)} 
                    />
                </div>
                <div className="col-lg-6 col-12 mt-5">
                    <label>تلفن منزل</label>
                    <input  className="form-input col-12"
                        dir="ltr"
                        type="text"
                        placeholder="تلفن منزل"
                        value={Phone}
                        onChange={(e) => setPhone(e.target.value)} 
                    />
                </div>
                <div className="col-lg-12 col-12 mt-5">
                <label>آدرس منزل</label>
                    <input  className="form-input col-12"
                        type="text"
                        placeholder="آدرس منزل"
                        value={Address}
                        onChange={(e) => setAddress(e.target.value)} 
                    />
                </div>
                <div className="col-lg-6 col-12 mt-5">
                    <label>مدرک تحصیلی</label>
                    <input  className="form-input col-12"
                       
                        type="text"
                        placeholder="دیپلم/فوق دیپلم/لیسانس/..."
                        value={Grade}
                        onChange={(e) => setGrade(e.target.value)} 
                    />
                </div>
                <div className="col-lg-6 col-12 mt-5">
                    <label>رشته تحصیلی</label>
                    <input  className="form-input col-12"
                       
                        type="text"
                        placeholder="طراحی/مدیریت/..."
                        value={Filde}
                        onChange={(e) => setFilde(e.target.value)} 
                    />
                </div>
                <div className="col-lg-12 col-12 mt-5">
                    <label className="form-input col-lg-6 col-12">در حال حاضر مشغول به تحصیل می باشم</label>
                    <input  className="form-input col-1"
                        name="in_educate"
                        type="radio"
                        value="بله"
                        onChange={(e) => setInEducate(e.target.value)} 
                    />
                    <label className="form-input col-2">بله</label>
                    <input  className="form-input col-1"
                        name="in_educate"
                        type="radio"
                        value="خیر"
                        onChange={(e) => setInEducate(e.target.value)} 
                    />
                    <label className="form-input col-2">خیر</label>
                </div>
                <div className="col-lg-12 col-12 mt-5">
                    <label className="form-input col-12">در چه زمینه ای مایل به همکاری با گالری کیمیاهستید؟</label>

                    <div className="col-lg-12 col-12">
                        <div className="col-lg-6 col-12">
                            <input  className="form-input"
                                name="in_educate"
                                type="checkbox"
                                value="فروشندگی در شعب"
                                onChange={handleCheckboxChange}
                            />
                            <label className="form-input">فروشندگی در شعب</label>
                        </div>
                        <div className="col-lg-6 col-12">
                            <input  className="form-input"
                                name="in_educate"
                                type="checkbox"
                                value="طراحی طلا(دستی - متریکس)"
                                onChange={handleCheckboxChange}
                            />
                            <label className="form-input">طراحی طلا(دستی - متریکس)</label>
                        </div>
                    </div>
                    <div className="col-lg-12 col-12">
                        <div className="col-lg-6 col-12">
                            <input  className="form-input"
                                name="in_educate"
                                type="checkbox"
                                value="گرافیک و عکاسی"
                                onChange={handleCheckboxChange}
                            />
                            <label className="form-input">گرافیک و عکاسی</label>
                        </div>
                        <div className="col-lg-6 col-12">
                            <input  className="form-input "
                                name="in_educate"
                                type="checkbox"
                                value="ساخت طلا"
                                onChange={handleCheckboxChange}
                            />
                            <label className="form-input">ساخت طلا</label>
                        </div>
                    </div>
                    <div className="col-lg-12 col-12">
                        <div className="col-lg-6 col-12">
                            <input  className="form-input"
                                name="in_educate"
                                type="checkbox"
                                value="تولید محصولات سنگی و بافتی"
                                onChange={handleCheckboxChange}
                            />
                            <label className="form-input">تولید محصولات سنگی و بافتی</label>
                        </div>
                        <div className="col-lg-6 col-12">
                            <input  className="form-input "
                                name="in_educate"
                                type="checkbox"
                                value="پلتفرم اینستاگرام"
                                onChange={handleCheckboxChange}
                            />
                            <label className="form-input">پلتفرم اینستاگرام</label>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 col-12 mt-5">
                    <label className="form-input col-12">سوابق کاری با ذکر محل تلفن محل کار</label>
                    <textarea  className="form-input col-12"
                        rows={4}
                        cols={50}
                        value={OldJob}
                        onChange={(e) => setOldJob(e.target.value)}
                    ></textarea>
                </div>
                <div className="col-lg-12 col-12 mt-5">
                    <label className="form-input col-12">علت کناره گیری از شغل سابق</label>
                    <input  className="form-input col-12"
                       
                       type="text"
                       
                       value={oldJobReject}
                       onChange={(e) => setoldJobReject(e.target.value)} 
                   />
                </div>
                <div className="col-lg-12 col-12 mt-5">
                    <label className="form-input col-12">مهارت های مرتبط با کار طلا یا فرشندگی</label>
                    <textarea  className="form-input col-12"
                        rows={4}
                        cols={50}
                        value={skill}
                        onChange={(e) => setskill(e.target.value)}
                    ></textarea>
                </div>
                <div className="col-lg-12 col-12 mt-5">
                    <label className="form-input col-12">رزومه</label>
                    <div className="col-12">
                        <input   
                            ref={fileInputRef}
                            onChange={handleFileChange} 
                            type="file" 
                            style={{display:"none"}}
                        />
                    
                        <input 
                            className="form-input col-lg-8 col-12 mt-1" 
                            placeholder="" 
                            type="text" 
                            disabled 
                            value={SelectedFile?SelectedFile.name:""}
                        />
                        <button className="submit-form-btn float-lg-left border-0 col-lg-2 col-4" onClick={attachFile}>انتخاب فایل</button>
                    </div>
                </div>
                <div className="col-lg-12 col-12 mt-5 d-lg-flex">
                    <div className="col-lg-10 col-12 d-flex flex-column">
                        <label className="col-12">لطفا تایید بفرمایید</label>
                        <div className="col-lg-10 col-12">
                            <input  className="form-input"
                                name="validate"
                                type="checkbox"
                                value="تکمیل اطلاعات فوق و ارسال رزومه حقی برای اینجانب جهت استخدام ایجاد نمی کند"
                                onChange={(e) => setvalideForm(e.target.value)} 
                            />
                            <label className="col-10">تکمیل اطلاعات فوق و ارسال رزومه حقی برای اینجانب جهت استخدام ایجاد نمی کند</label>
                        </div>
                    </div>
                    <button className="submit-form-btn col-2 border-0"  onClick={handleSubmit}>ارسال</button>
                </div>
            </div>
        </div>
    );

}

export default EmploymentForm;